<template>
  <div class="page-title-area">
    <div class="container">
      <div v-if="!loading">
        <div class="articles">
          <b-tabs content-class="mt-3">
            <b-tab title="Reading List" active>
              <ArticleSecond
                v-for="(article, i) in blogs"
                :key="i"
                :article="article"
                :bookMarks="bookMarks"
                @bookMarkBlog="toggleBookMark"
              />
            </b-tab>
            <h4 class="ml-2" v-if="blogs.length == 0">Reading List Empty</h4>
          </b-tabs>
        </div>
      </div>
      <div class="articles" v-if="loading">
        <ArticleSecondSkeleton v-for="(article, i) in 3" :key="i" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ArticleSecond from "@/components/other-pages/Blogs/ArticleSecond";
import ArticleSecondSkeleton from "@/components/other-pages/Blogs/ArticleSecondSkeleton";
export default {
  data() {
    return {
      blogs: [],
      bookMarks: [],
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  watch: {
    user(newValue, oldValue) {
      this.getBookMarks();
    }
  },
  components: {
    ArticleSecond,
    ArticleSecondSkeleton
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    this.getBookMarks();
  },
  methods: {
    getBookMarks() {
      if (this.user && this.user.uid) {
        this.blogs = [];
        this.$store
          .dispatch("user/getUserBlogBookMarks", this.user.uid)
          .then(bookMarks => {
            this.bookMarks = bookMarks;
            if (bookMarks.length == 0) {
              this.loading = false;
            } else {
              bookMarks.forEach(blog => {
                this.getBlog(blog.id);
              });
            }
          });
      }
    },
    getBlog(id) {
      this.$store.dispatch("listings/getBlogById", id).then(blog => {
        this.blogs.push(blog);
        this.loading = false;
      });
    },
    toggleBookMark(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (data.type == "add") {
          this.$store.dispatch("user/addBookMarkBlog", data.blog).then(() => {
            this.getBookMarks();
            console.log("Bookmarked");
          });
        } else {
          this.$store
            .dispatch("user/removeBookMarkBlog", data.blog)
            .then(() => {
              this.blogs.forEach(blog => {
                if (blog.id == data.blog.id) {
                  let index = this.blogs.indexOf(blog);
                  this.blogs.splice(index, 1);
                }
              });
              console.log("Removed bookmark");
            });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-title-area {
  background: none;
  padding-top: 72px;
  padding-bottom: 20px;
  margin-top: 100px;
  text-align: left;
}
.articles {
  text-align: left;
  padding-right: 300px;
}
</style>
